module.exports = __webpack_public_path__ + "img/number-black-25.2158559a.png";